import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent implements OnInit {
  title: string = '';
  isConfirm: boolean = false;
  isDocumentPreview: boolean = false;
  body: string = '';
  @Output() resolveModal = new EventEmitter<string>();

  constructor(public readonly bsModalRef: BsModalRef) {}

  ngOnInit() {
    if (this.isConfirm) {
      this.body = 'Are you sure?';
    }
  }

  confirm() {
    this.resolveModal.emit('confirm');
    this.bsModalRef.hide();
  }
}
